export default __webpack_public_path__ + "static/media/accx.4c36696d.svg";